import { StyleSheet } from 'react-native';

import { Border, Color } from '@/GlobalStyles';

export const ICONS = {
  ARROW_DOWN: require('react-native-dropdown-picker/src/themes/light/icons/arrow-down.png'),
  ARROW_UP: require('react-native-dropdown-picker/src/themes/light/icons/arrow-up.png'),
  TICK: require('react-native-dropdown-picker/src/themes/light/icons/tick.png'),
  CLOSE: require('react-native-dropdown-picker/src/themes/light/icons/close.png'),
};

export default StyleSheet.create({
  container: {},
  style: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: 50,
    borderRadius: Border.br_3xs,
    borderWidth: 1,
    borderColor: Color.colorGray_200,
    paddingHorizontal: 22,
    paddingVertical: 3,
    backgroundColor: Color.blanc,
  },
  label: {
    height: 36,
    paddingVertical: 8,
    paddingHorizontal: 9,
    marginLeft: -16,
    color: Color.MainNoir,
    borderColor: 'transparent',
    borderWidth: 1,
    borderRadius: 18,
    fontFamily: 'Roboto_Regular',
    fontSize: 14,
  },
  labelContainer: {
    flexDirection: 'row',
  },
  arrowIcon: {
    width: 14,
    height: 14,
  },
  tickIcon: {
    width: 20,
    height: 20,
  },
  closeIcon: {
    width: 30,
    height: 30,
  },
  badgeStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 10,
    backgroundColor: 'red',
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  badgeDotStyle: {
    width: 10,
    height: 10,
    borderRadius: 10 / 2,
    marginRight: 8,
    backgroundColor: 'green',
  },
  badgeSeparator: {
    width: 5,
  },
  listBody: {
    height: '100%',
  },
  listBodyContainer: {
    flexGrow: 1,
    alignItems: 'center',
  },
  dropDownContainer: {
    position: 'absolute',
    backgroundColor: Color.blanc,
    borderRadius: Border.br_3xs,
    borderColor: Color.colorGray_200,
    borderWidth: 1,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  modalContentContainer: {
    flexGrow: 1,
  },
  listItemContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 40,
    flexDirection: 'row-reverse',
  },
  listItemLabel: {
    flex: 1,
    color: Color.MainNoir,
    fontFamily: 'Roboto_Regular',
    fontSize: 14,
  },
  itemSeparator: {
    height: 1,
    backgroundColor: Color.colorGray_200,
  },
  iconContainer: {
    marginRight: 10,
  },
  arrowIconContainer: {
    marginLeft: 10,
  },
  tickIconContainer: {
    marginRight: 10,
  },
  closeIconContainer: {
    marginLeft: 10,
  },
  listParentLabel: {},
  listChildLabel: {},
  listParentContainer: {
    paddingLeft: 20,
  },
  listChildContainer: {
    paddingLeft: 40,
  },
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    borderBottomColor: Color.colorGray_200,
    borderBottomWidth: 1,
  },
  searchTextInput: {
    flexGrow: 1,
    flexShrink: 1,
    margin: 0,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 8,
    borderColor: Color.colorGray_200,
    borderWidth: 1,
    color: Color.MainNoir,
  },
  flatListContentContainer: {
    flexGrow: 1,
  },
  customItemContainer: {},
  customItemLabel: {
    fontStyle: 'italic',
  },
  listMessageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 22,
  },
  listMessageText: {},
  selectedItemContainer: {},
  selectedItemLabel: {},
  modalTitle: {
    fontSize: 18,
    color: Color.MainNoir,
  },
  extendableBadgeContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    flex: 1,
  },
  extendableBadgeItemContainer: {
    marginVertical: 3,
    marginEnd: 7,
  },
});
